/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  API_AUTH_USERNAME,
  API_AUTH_PASSWORD,
  API_BASE_URL,
} from "../../Constant/Global";
import axios from "axios";
import { toast } from "react-toastify";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./partnerLogoSlider.css";
import { useNavigate } from "react-router-dom";
import DataNotFound from "../dataNotFound/DataNotFound";
import { useDashBoardData } from "../../context/dashboardDataContext/DashboardDataContext";

const PartnerLogoSlider = () => {
  const { dashboardData } = useDashBoardData();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 8,
      slidesToSlide: 8, // Display 5 items at a time
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 3,
      slidesToSlide: 3, // Display 3 items at a time
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 2,
      slidesToSlide: 2, // Display 1 item at a time
    },
  };
  return (
    <>
      {dashboardData?.co_partner?.length > 0 ? (
        <div className="item desktop_cat">
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={false}
            autoPlaySpeed={5000}
          >
            {dashboardData?.co_partner?.map((item) => {
              return (
                <div
                  className="category-img-div"
                  key={item.id}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src={item.image}
                    alt="category-images"
                    className="img-fluid rounded"
                    // loading="lazy"
                  />
                </div>
              );
            })}
          </Carousel>
        </div>
      ) : (
        <DataNotFound />
      )}
    </>
  );
};

export default PartnerLogoSlider;
